import {HomeMeasurementStatus} from "../../list/found-measurement";

export function isMailingInfoSet(homeStatus: HomeMeasurementStatus | undefined) {
  return homeStatus !== undefined && homeStatus !== "WAITING_FOR_MAILING_INFO";
}
